/**
 * Adzuki
 * chatbot.js
 */

(function Chatbot($, Adzuki)
{
	"use strict";

	// if changing the serviceUrl, also change it in components/ChatbotComponent.php
	var serviceUrl               = 'https://cpmaxx.cruiseplannersnet.com/Ai/chatBot/api/v1/prediction/',
		maxReferences            = 10,
		mode                     = 'ask-maxx',
		isDarkMode               = false,
		askMaxxquestionAsked     = false,
		maxxIntelligenceAsked    = false,
		lastAnswerBad            = false,
		isExpanded               = false,
		// useEndpointOverride      = false,
		endpointOverride         = 'e96551ca-1928-4c49-8f65-d527481dd3f6',
		originalHeight           = 0,
		badQuestionDetails       = {},
		askMaxxQuestion          = '',
		maxxIntelligenceQuestion = '',
		askMaxxErrorRetry        = 'Woof! That didn\'t work. Please enter another question and I\'ll try again',
		alertIcon                = '<i class="fa fa-exclamation-triangle"></i>',
		askMaxxErrorResponse     = 'Woof! Can you try asking that again?',
		askMaxxEndpoint          = 'e0a0e6a7-74f0-49f2-83c9-79d77d6ed1e8',
		blueColor                = '#0080C5',
		greenColor               = '#39B54A',
		topic                    = '',
		intros                   = [
			'Woof! I\'m Maxx, your Cruise Planners assistant! 🐾 I\'m training to be the smartest dog bot ever! You can ask me about sailings, destinations, our trusted partners, and information from CP Genie. Let\'s embark on a tail-wagging adventure together! 🐶🚢',
			'Bark! I\'m Maxx, your Cruise Planners assistant! 🐾 I\'m on a mission to become the top dog in travel assistance! You can ask me about our trusted partners, information from CP Genie, destinations, and sailings. Ready to fetch some answers? 🐶✈️',
			'Howdy! I\'m Maxx, your Cruise Planners assistant! 🐾 I\'m working hard to be the best dog bot around! You can ask me about content from CP Genie, sailings, our trusted partners, and destinations. Let\'s sniff out the best information for you! 🐶🌍'
		],
		intelligenceIntros       = [
			'Hello! 👋 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
			'Hi! 👋 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
			'Hey! 👋 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
			'Woof! 🐶 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
		],
		endpoints                = {
			Destinations: {
				id  : 'e0a0e6a7-74f0-49f2-83c9-79d77d6ed1e8',
				icon: 'fa-globe'
			},
			Partners: {
				id  : '47a7329e-6ee9-4885-bfef-04c5112ce777',
				icon: 'fa-handshake'
			},
			Sailings: {
				id  : '7c8412a2-d553-4d05-8c9e-7df8fae905a9',
				icon: 'fa-ship'
			},
			'CP Genie': {
				id  : 'e96551ca-1928-4c49-8f65-d527481dd3f6',
				icon: 'fa-fire'
			}
		};

	$(document).ready(function documentReady()
	{
		// Ensure tooltip plugin is initialized
		/*
		if ($.fn.tooltip) {
			$('[data-toggle="tooltip"]').tooltip({
				placement: function _tooltipPlacement(tooltip, element) {
					// Use 'left' placement for elements with class 'chatbot-topics-label'
					if ($(element).hasClass('chatbot-topics-label')) {
						return 'left';
					}
					// Use default placement for other tooltips
					return tooltip.options.placement;
				}
			});
		}
		*/

		// if android, attempt to detect the keyboard and collapse the height of the window
		if ((/android/i).test(navigator.userAgent.toLowerCase())) {
			$(window).on('resize orientationchange', function _checkIfResized() {
				if (originalHeight === 0) {
					originalHeight = $('.chatbot-response').css('height');
					$('.chatbot-response').css('height', '15%');
				} else {
					$('.chatbot-response').css('height', originalHeight);
					originalHeight = 0;
				}
			});
		}

		// Add this check at the beginning of the documentReady function
		isDarkMode = $('body').hasClass('theme--dark');

		// Add global click event listener to remove tooltips
		$(document).on('click', function _clearAllTooltips() {
			if ($.fn.tooltip) { // Check if tooltip function is available
				$('[data-toggle="tooltip"]').tooltip('destroy');
			}
		});

		// when the logo is clicked, show the chatbot
		$('.chatbot-logo-container').on('click', function _chatBotClicked() {
			showChatBot();
		});

		// when the close button is clicked, hide the chatbot
		$('#chatbot-close').on('click', function _chatBotClose() {
			hideChatBot();
		});

		// copy the chatbot's response to the clipboard
		$('.chatbot-contents').on('click', '.chatbot-reply-copy', function _chatBotReplyCopy(e) {
			var chatBotReplyId = $(this).data('chatbot-reply-id'),
				$obj           = $(`#${chatBotReplyId}`);

			e.preventDefault();

			if ($obj.length === 0) {
				console.error('Element not found:', chatBotReplyId);
				Adzuki.StatusMessage('Error', 'Failed to find the response to copy');
				return;
			}

			copyResponseToClipboard($obj);
		});

		// send the response to the snippets system
		$('.chatbot-contents').on('click', '.chatbot-snippets', function _chatBotSnippets() {
			var chatBotReplyId = $(this).data('chatbot-reply-id'),
				$obj           = $(`#${chatBotReplyId}`);

			sendToSnippets($obj);
		});


		// send the history item to the snippets
		$('.chatbot-contents').on('click', '.history-snippets', function _historySnippets() {
			var historyId = $(this).data('history-id'),
				$obj           = $('#history-response-' + historyId);

			sendToSnippets($obj);
		});

		// Add click event for copy to clipboard
		$('.chatbot-contents').on('click', '.history-copy', function _copyHistoryToClipboard() {
			var historyId    = $(this).data('history-id'),
				$historyItem = $('#' + historyId);
			console.log($historyItem.find('.history-response p').html());
			copyResponseToClipboard($historyItem.find('.history-response p'));
		});

		// send the message to the chatbot
		$('#chatbot-submit').on('click', function _chatBotSubmit() {
			var chatbotMessage = $('#chatbot-entry').val().trim();

			$(this).tooltip('hide');

			$('.chatbot-specificity').html('');

			if (chatbotMessage === '') {
				askMaxxquestionAsked = false;

				if (lastAnswerBad === true) {
					maxxBubble(alertIcon + ' Please provide your feedback so I can learn what to do next!', '', false, true);
				} else {
					maxxBubble(alertIcon + ' I\'ll need you to ask a question first so that I can dig up the answer!', '', false, true);
				}

				scrollContents($('.chatbot-response'));
			} else {
				sendMessage(chatbotMessage);
			}
		});

		// restart the chatbot
		$('#chatbot-restart').on('click', function _chatBotRestart() {
			if (mode === 'ask-maxx') {
				restartChatBot();

				setSpecificity('concise');
			} else {
				restartMaxxIntelligence();
			}
		});

		// reloads the intro screens for each section depending on the mode
		$('#chatbot-home').on('click', function _chatBotHome() {
			if (mode === 'ask-maxx') {
				$('.chatbot-details-container').hide();
				$('.ask-maxx-card-intro').show();

				// IF they had started providing feedback, and bailed, then reset the variables
				$('#chatbot-entry').css('background-color', '#EFEFEF');
				$('#chatbot-entry').attr('placeholder', 'Ask me a question...');
				lastAnswerBad = false;
			} else {
				$('.maxx-intelligence-details-container').hide();
				$('.maxx-intelligence-card-intro').show();
			}
		});

		// Modify the keypress event listeners
		$('#chatbot-entry').on('keydown', function _chatBotEntryKeypress(event) {
			if (event.which === 13 && !event.shiftKey) {
				event.preventDefault();
				$('#chatbot-submit').click();
			}
		});

		$('#maxx-intelligence-entry').on('keydown', function _maxxIntelligenceEntryKeypress(event) {
			if (event.which === 13 && !event.shiftKey) {
				event.preventDefault();
				$('#maxx-intelligence-submit').click();
			}
		});

		// Remove any existing mouseover/mouseout handlers
		$('.chatbot-logo-container').off('mouseover mouseout');

		// Set the user photo in the after element
		setUserPhotoInAfter();

		// Set default active class for 'concise' specificity option
		$('.chatbot-specificity-option-button[data-specificity="concise"]').addClass('active');

		// Add click event handler for specificity option buttons
		$('.chatbot-specificity-option-button').on('click', function _chatBotSpecificityOptionButtonClicked() {
			var specificity = $(this).data('specificity');
			$('.chatbot-specificity-option-button').removeClass('active');
			$(this).addClass('active');

			setSpecificity(specificity);
		});

		// Expand/Contract chatbot
		$('.chatbot-expand').on('click', function _chatBotExpandClicked() {
			var $icon     = $(this).find('i'),
				$contents = $('.chatbot-contents');

			if ($icon.hasClass('fa-expand-alt')) {
				// Expand
				isExpanded = true;
				$icon.removeClass('fa-expand-alt').addClass('fa-compress-alt');
				$icon.attr('title', 'Contract');
				$icon.attr('data-original-title', 'Contract');
				$contents.css({
					position: 'fixed',
					zIndex  : 9999,
					top     : '10%',
					left    : '10%',
					width   : '80%',
					height  : '80%'
				});

				$('.chatbot-entry').css('width', '100%');
				$('.maxx-intelligence-details-container').css('height', '100%');
			} else {
				// Contract
				isExpanded = false;

				$icon.removeClass('fa-compress-alt').addClass('fa-expand-alt');
				$icon.attr('title', 'Expand');
				$icon.attr('data-original-title', 'Expand');

				$contents.css({
					position: '',
					top     : '',
					left    : '',
					width   : '',
					height  : '',
					zIndex  : ''
				});

				$('.chatbot-entry').css('width', '445px');
				$('.maxx-intelligence-details-container').css('height', '100%');
			}

			// Reset the tooltip
			$icon.tooltip('destroy').tooltip();
		});

		// Add click event handler for chatbot type buttons
		$('.chatbot-type').on('click', function _chatBotTypeClicked() {
			var $this = $(this),
				type  = $this.data('type');

			// Remove active styles from all .chatbot-type elements
			$('.chatbot-type').removeClass('chatbot-type-active');

			// Add active styles to the clicked element
			$this.addClass('chatbot-type-active');

			if (type === 'ask-maxx') {
				$('.chatbot-ask-maxx-container').show();
				$('.chatbot-maxx-intelligence-container').hide();

				$this.css({
					color                : greenColor,  // Use greenColor variable
					'border-bottom-color': greenColor  // Use greenColor variable
				});

				mode = 'ask-maxx';

				$('.chatbot-specificity').html('');
			} else if (type === 'maxx-intelligence') {

				$this.css({
					color                : blueColor,  // Use blueColor variable
					'border-bottom-color': blueColor  // Use blueColor variable
				});

				$('.chatbot-ask-maxx-container').hide();
				$('.chatbot-maxx-intelligence-container').show();

				mode = 'maxx-intelligence';

				showMaxxIntelligence();

				$('.chatbot-specificity').html(`<div class="maxx-intelligence-options">
						<div class="maxx-intelligence-option">
							<button class="maxx-intelligence-option-button active" data-option="generate">Generate Content</button>&nbsp;
							<button class="maxx-intelligence-option-button" data-option="history">History</button>
						</div>
					</div>`);
			}
		});

		// starts ask maxx ui
		$('.ask-maxx-start').on('click', function _chatBotAskMaxxStart() {
			// show the details container
			$('.chatbot-details-container').show();
			$('.ask-maxx-card-intro').hide();

			setSpecificity('concise');
		});

		// starts maxx intelligence ui
		$('.maxx-intelligence-start').on('click', function _chatBotMaxxIntelligenceStart() {
			$('.maxx-intelligence-details-container').show();
			$('.maxx-intelligence-card-intro').hide();

			if ($('#maxx-intelligence-session-id').val() === '') {
				// if there's no session id set for maxx intelly, set it
				setMaxxIntelligenceSessionId();

				// if it's the first time, show a random intro
				maxxBubble(getRandomIntro());
			}
		});

		// sends the request to the maxx intelligence system
		$('#maxx-intelligence-submit').on('click', function _chatBotSubmit() {
			var maxxIntelligenceMessage = $('#maxx-intelligence-entry').val();

			if (maxxIntelligenceMessage === '') {
				maxxIntelligenceAsked = false;
				maxxBubble(alertIcon + ' I\'ll need you to ask a question first so that I can dig up the answer!', '', false, true);	

				scrollContents($('.maxx-intelligence-response'));
			} else {
				sendMaxxIntelligence(maxxIntelligenceMessage);
			}
		});

		// Add click event handler for chatbot choice buttons
		$('.chatbot-container').on('click', '.chatbot-choice', function _chatBotChoiceClicked() {
			var $this    = $(this),
				endpoint = $this.data('endpoint');

			toggleTopicLabelAnimation(false);

			$(this).addClass('chatbot-choice-active');
			$('.chatbot-choice').not(this).removeClass('chatbot-choice-active');
			askMaxxEndpoint = endpoint;
		});

		// Add click handler for the followup bubbles
		$('.chatbot-container').on('click', '.chatbot-followup-bubble', function _followupBubbleClick() {
			const followupQuestion = $(this).data('followup');
			const endpoint         = $(this).data('endpoint');

			if (endpoint) {
				endpointOverride = endpoint;
			}

			// useEndpointOverride = true;

			$('#chatbot-entry').val(followupQuestion);
			$('#chatbot-submit').click();
		});

		// show the chat window or the history window
		$('.chatbot-container').on('click', '.maxx-intelligence-option-button', function _maxxIntelligenceOptionButtonClicked() {
			var $this  = $(this),
				option = $this.data('option');

			$('.maxx-intelligence-option-button').removeClass('active');
			$(this).addClass('active');

			if (option === 'generate') {
				$('.maxx-intelligence-response').show();
				$('.maxx-intelligence-history').hide();
			} else if (option === 'history') {
				$('.maxx-intelligence-response').hide();
				$('.maxx-intelligence-history').show();
				loadMaxxIntelligenceHistory();
			}
		});

		// Add click event handler for microphone icons
		$('.chatbot-microphone').on('click', function _chatBotMicrophoneClicked() {
			$(this).toggleClass('active');
			if ($(this).hasClass('active')) {
				textToSpeech();
			} else if (window.recognition) {
				window.recognition.stop();
			}
		});

		// adds the last question into the question box
		$('.chatbot-container').on('click', '.ask-again', function _askMaxxAgain(e) {
			var question = $(this).data('question');

			e.preventDefault();

			$('#chatbot-entry').val(question);
		});

		$('.chatbot-container').on('click', '.chatbot-ask-again', function _askMaxxAgain(e) {
			var question = $(this).data('question');

			e.preventDefault();

			if (mode === 'ask-maxx') {
				$('#chatbot-entry').val(question);
			} else {
				$('#maxx-intelligence-entry').val(question);
			}
		});

		// triggers the drop down if the topic is clicked
		$('.chatbot-container').on('click', '.topic-label', function _topicLabelClicked(e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).closest('.chatbot-topics-label-wrapper').find('.dropdown-toggle').dropdown('toggle');
		});

		$('.chatbot-container').on('click', '.animate-border', function _topicLabelClicked(e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).closest('.chatbot-topics-label-wrapper').find('.dropdown-toggle').dropdown('toggle');
		});

		// if the backdrop is clicked, hide the chatbot
		$('body').on('click', '.chatbot-backdrop', function _backdropClicked() {
			hideChatBot();
		});

		$('.chatbot-container').on('click', '.feedback-button-yes', function _feedbackButtonYesClicked() {
			askMaxxquestionAsked = false;
			lastAnswerBad        = true;

			maxxBubble('Fur-tastic! 🐾 Please add your thoughts in the input field highlighted in red below.', 'BAD', false);
			
			// we're going to modify the text input field to have a different background color and placeholder
			$('#chatbot-entry').css('background-color', '#ffcccc');
			$('#chatbot-entry').attr('placeholder', 'Type your feedback here...');
			$('#chatbot-entry').addClass('feedback-input');

			// hide the feedback buttons
			$('.feedback-button-yes').addClass('hidden');
			$('.feedback-button-no').addClass('hidden');

			scrollContents($('.chatbot-response'));
		});

		$('.chatbot-container').on('click', '.feedback-button-no', function _feedbackButtonNoClicked() {
			// Send feedback data to the server
			Adzuki.Ajax.post('/Ai/sendFeedback/', badQuestionDetails)
				.then(() => {
					// Hide feedback buttons
					$('.feedback-button-yes, .feedback-button-no').addClass('hidden');

					// Reset state and display message
					lastAnswerBad = false;
					const message = 'No problem at all. If you ever want to share, I\'m all ears! Feel free to keep those questions coming! 🐶✨';
					maxxBubble(message, '', false);
					scrollContents($('.chatbot-response'));
				})
				.catch(error => {
					console.error('Error sending feedback:', error);
					// Handle error (e.g., show error message to user)
				});
		});

		$('.chatbot-container').on('click', '.feedback-thumbs-up', function _thumbsUpClicked() {
			// Reset both thumbs to default color
			$(this).closest('.chatbot-feedback').find('i').css('color', '#CCC');

			$(this).find('i').css('color', greenColor);

			askMaxxquestionAsked = false;
			maxxBubble( 'Pawsome! 🐶 Your feedback helps me wag my tail even more. If you need anything else, just give me a bark!', 'GOOD', false);
			askMaxxquestionAsked = true;
			scrollContents($('.chatbot-response'));
		});

		$('.chatbot-container').on('click', '.feedback-thumbs-down', function _thumbsDownClicked() {
			var $this           = $(this),
				chatBotReplyId  = $this.data('chatbot-reply-id'),
				question        = $this.data('question'),
				$obj            = $(`#${chatBotReplyId}`),
				response        = stripHtmlAndFormat($obj.html().trim()),
				feedbackButtons = `<br><br>
					<button class="btn btn-primary feedback-button-yes" data-chatbot-reply-id="${chatBotReplyId}" data-question="${question}" data-response="${response}">Yes</button> 
					<button class="btn btn-primary feedback-button-no" data-chatbot-reply-id="${chatBotReplyId}" data-question="${question}" data-response="${response}">No</button>
				`;

			// Reset both thumbs to default color
			$(this).closest('.chatbot-feedback').find('i').css('color', '#CCC');

			// set the color to red
			$(this).find('i').css('color', '#dc3545');

			// set the details of the feedback request
			badQuestionDetails = {
				session_id : $('#chatbot-session-id').val(),
				question   : question,
				response   : response,
				endpoint   : askMaxxEndpoint,
				explanation: null
			};

			// sets the vars so we know that it's not a traditional request
			askMaxxquestionAsked = false;
			lastAnswerBad        = true;
			
			maxxBubble('Ruff! 🐾 Thanks for the feedback. I\'ll work on fetching better responses.  Would you provide input on what was wrong with the response?' + feedbackButtons, '', false);

			// Clear the suggestions
			$('.chatbot-specificity').html('');

			// scrolls the content
			scrollContents($('.chatbot-response'));
		});

		$('.chatbot-container').on('click', '.chatbot-save-conversation', function _saveConversation() {
			var conversation        = collectChatbotConversation();
			var sessionId           = $('#chatbot-session-id').val();
			var saveConversationUrl = Adzuki.erez_url + Adzuki.base_uri + '/Ai/askMaxxHistory';
			
			if (askMaxxquestionAsked === false && lastAnswerBad === false) {
				maxxBubble(alertIcon + ' Saving conversation will be available after your first question is asked.', '', false, true);	
				scrollContents($('.chatbot-response'));
				return;
			}

			// Example: Send to server
			Adzuki.Ajax.post('/Ai/saveConversation/', {
				conversation: JSON.stringify(conversation),
				sessionId   : sessionId
			}).then(function _processResponse(response) {
				// Handle the response from the server
				askMaxxquestionAsked = false;

				maxxBubble(`Woof! 🐾 I've added this to your saved conversations! To view all your saved conversations, visit the Artificial Intelligence History in the Operations Hub or click <b><a href="${saveConversationUrl}" target="_blank">here</a></b>!`, 'SAVED', false);
				scrollContents($('.chatbot-response'));
				askMaxxquestionAsked = true;
			}).catch(function _trapError(error) {
				console.error('Error saving conversation:', error);
				Adzuki.StatusMessage('Error', 'Failed to save the conversation. Please try again.');
			});
		});

		// trigger ask maxx from mobile index (main->mobileIndex)
		$('.mobile-ask-maxx').on('click', function _showMaxx(e) {
			e.preventDefault();

			showChatBot();
		});
	});

	// --- local functions ---

	// advisor bubble
	function advisorBubble(message) {
		// const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
		const formattedDiv = `
			<div class="chatbot-user-label ${isDarkMode ? 'theme--dark' : ''}">${$('#chatbot-agent-name').val()}</div>
			<div class="chatbot-user-question ${mode === 'maxx-intelligence' ? 'maxx-intelligence' : ''}">
				${sanitizeHTML(message)}
			</div>
			<div class="clearfix"></div>
		`;

		if (mode === 'ask-maxx') {
			$('.chatbot-response').append(formattedDiv);
		} else {
			$('.maxx-intelligence-response').append(formattedDiv);
		}
	}

	// collect chatbot conversation information
	function collectChatbotConversation() {
		var conversation     = [];
		var $chatbotResponse = $('.chatbot-response');
		var $element;
		var replyId;
		var $referencesContainer;
		var references;
		var $reference;
		var topic;

		// var currentTopic = Object.keys(endpoints).find(key => endpoints[key].id === askMaxxEndpoint) || 'Unknown';

		$chatbotResponse.children().each(function _iterateBubbles(index, element) {
			$element = $(element);
			if ($element.hasClass('chatbot-user-question')) {
				conversation.push({
					type   : 'user',
					message: $element.text().trim()
				});
			} else if ($element.hasClass('chatbot-bot-reply')) {
				replyId              = $element.attr('id');
				$referencesContainer = $element.nextAll('.chatbot-references-container').first();
				references           = [];
				topic                = $element.data('topic');

				if ($referencesContainer.length > 0) {
					$referencesContainer.find('.chatbot-reference').each(function _iterateReferences() {
						$reference = $(this);
						references.push({
							url     : $reference.find('a').attr('href'),
							title   : $reference.find('a span:not(.reference-subtitle)').text().trim(),
							subtitle: $reference.find('.reference-subtitle').text().trim(),
							image   : $reference.find('img').attr('src') || null
						});
					});
				}

				conversation.push({
					type      : 'bot',
					message   : $element.html().trim(),
					id        : replyId,
					references: references,
					topic     : topic || 'Unknown'
				});
			}
		});

		return conversation;
	}

	function copyResponseToClipboard($obj)
	{
		var responseText = $obj.html();

		// Check if $obj is valid and has content
		if ($obj.length === 0 || !responseText) {
			console.error('Invalid object or empty response');
			Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard.');
			return;
		}

		function listener(e) {
			e.clipboardData.setData("text/html", responseText);
			e.clipboardData.setData("text/plain", responseText);
			e.preventDefault();
		}

		try {
			document.addEventListener("copy", listener);
			document.execCommand("copy");
			document.removeEventListener("copy", listener);

			askMaxxquestionAsked  = false;
			maxxIntelligenceAsked = false;

			if (mode === 'ask-maxx') {
				maxxBubble('Woof! 🐾 I\'ve copied your response to the clipboard!', '', false);
				scrollContents($('.chatbot-response'));
			} else {
				if ($('.maxx-intelligence-option-button.active').data('option') === 'history') { // eslint-disable-line no-lonely-if
					Adzuki.StatusMessage('Success', 'Copied to clipboard');
				} else {
					maxxBubble('Woof! 🐾 I\'ve copied your response to the clipboard!', '', false);
					scrollContents($('.maxx-intelligence-response'));
				}
			}
		} catch (err) {
			console.error('Unable to copy to clipboard', err);
			Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard.');
			return;
		}
	}

	// New function to add a new set of references
	function addNewReferences(sources, totalReferences, uniqueId, question) {
		// Remove duplicate sources
		const uniqueSources = [...new Set(sources)];

		const containerHtml = `
			<div class="chatbot-references-container" id="ref-container-${uniqueId}">
				<div class="chatbot-references-wrapper" id="ref-${uniqueId}">
					<div class="chatbot-reference-header chatbot-reference-toggle">
						<span>References (${uniqueSources.length})</span>
						<i class="fa fa-chevron-right chatbot-reference-toggle"></i>
					</div>
					<div class="chatbot-references-content" style="display: none;">
						${uniqueSources.map(source => `
							<div class="chatbot-reference" data-source="${encodeURIComponent(source)}">
								<a href="${source}" target="_blank" title="${source}">${source}</a>
							</div>
						`).join('')}
					</div>
				</div>
			</div>
		`;

		if (mode === 'ask-maxx') {
			$('.chatbot-response').append(containerHtml);
		} else {
			$('.maxx-intelligence-response').append(containerHtml);
		}

		// Add click event to toggle references visibility for this specific set
		$(`#ref-${uniqueId} .chatbot-reference-header`).on('click', function _toggleReferences() {
			$(this).find('.chatbot-reference-toggle').toggleClass('fa-chevron-right fa-chevron-down');
			$(`#ref-${uniqueId} .chatbot-references-content`).slideToggle();
		});

		// Handle chatbot references in mobile apps 
		$(`#ref-container-${uniqueId} .chatbot-reference`).on("click", function _handleReferenceClick() {
		    const href = $(this).find("a").attr("href");
		    var isAndroid = (/android/i).test(navigator.userAgent.toLowerCase());

	        if (isAndroid) {
	            window.appInterface.postMessage(href);
	        }
	        else if (isIOS || isIpadOS) {
				window.webkit.messageHandlers.onClick.postMessage(href);
			}
		});

		// Format the new references
		$(`#ref-container-${uniqueId} .chatbot-reference`).each(function _formatReferences() {
			formatSingleReference($(this));
		});
	}

	function disableChatbotEntry()
	{
		$('#chatbot-entry').val('')
		.prop('disabled', true);

		$('#chatbot-submit').prop('disabled', true);
	}

	function enableChatbotEntry()
	{
		var isAndroid = (/android/i).test(navigator.userAgent.toLowerCase());

		if (isAndroid) {
			$('#chatbot-entry').val('')
			.prop('disabled', false);
		} else {
			$('#chatbot-entry').val('')
			.prop('disabled', false)
			.trigger('focus');
		}

		$('#chatbot-submit').prop('disabled', false);
	}

	// New function to format a single reference
	function formatSingleReference($element) {
		var encodedSource = $element.data('source');

		// Make an AJAX GET request
		Adzuki.Ajax.get('/Ai/transformReference/' + encodedSource)
		.then(function success(response) {
			// Handle the successful response
			updateSingleReference($element, response);
		})
		.catch(function error(err) {
			console.error('Error fetching details for', encodedSource, err);
		});
	}

	// New function to update a single reference
	function updateSingleReference($element, response) {
		const imageUrl = response.image || 'https://cpmaxx.cruiseplannersnet.com/images/noimage-available.png';
		const subtitle = response.subtitle;
		let updatedHtml = `
			<a href="${response.url}" target="_blank">
				<img src="${imageUrl}"
					alt="${response.title}"
					class="reference-image"
					onerror="this.src='https://cpmaxx.cruiseplannersnet.com/images/noimage-available.png'">
				<span style="padding-left: 10px">${response.title}</span>
		`;

		// Add subtitle if it's not empty
		if (subtitle && subtitle.trim() !== '') {
			updatedHtml += `<br><span class="reference-subtitle">${subtitle}</span>`;
		}

		updatedHtml += `</a>`;

		$element.html(updatedHtml);
	}

	// Function to format the response
	function formatResponse(response) {
		// Create a new variable for the formatted response
		let formattedResponse = response;

		// Replace newlines with <br> tags
		formattedResponse = formattedResponse.replace(/\r\n|\r|\n/g, '<br>');

		// Replace ### headings with <h4> tags
		formattedResponse = formattedResponse.replace(/#{1,6}\s(.*?)<br>/g, '<h4>$1</h4>');

		// Replace **text** with <b>text</b>
		formattedResponse = formattedResponse.replace(/\*\*?(.*?)\*\*?/g, '<b>$1</b>');

		// Replace links [text](url) with <a> tags and conditionally prepend inapp://chatbot/ for mobile devices
		if (isMobileDevice()) {
		    // For mobile devices, prepend "inapp://chatbot/" to the URL
		    formattedResponse = formattedResponse.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="inapp://chatbot/$2" target="_blank">$1</a>');
		} else {
		    // For non-mobile devices, leave the URL unchanged
		    formattedResponse = formattedResponse.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
		}

		return formattedResponse;
	}

	// Function to generate a random string of 25 characters
	function generateRandomString() {
		// Define the set of characters to choose from
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
			i      = 0,
			result = '';

		// Loop 25 times to create a 25-character string
		for (i = 0; i < 25; i++) {
			// Append a random character from the 'characters' string to the result
			result += characters.charAt(Math.floor(Math.random() * characters.length));
		}
		// Return the generated random string
		return result;
	}

	// get random intro
	function getRandomIntro() {
		const randomIndex = Math.floor(Math.random() * intros.length);
		var intro = '';

		if (mode === 'ask-maxx') {
			intro = intros[randomIndex];
		} else {
			intro = intelligenceIntros[randomIndex];
		}

		return intro;
	}

	// hide chatbot
	function hideChatBot() {
		var $icon     = $('.chatbot-expand').find('i').first();
		var $contents = $('.chatbot-contents');

		// Hide and reset main containers
		$('.chatbot-contents')
			.slideUp()
			.addClass('hidden');
		$('.chatbot-references').addClass('hidden');

		// Remove backdrop
		$('.chatbot-backdrop').fadeOut(function _removeBackdrop() {
			$(this).remove();
		});

		// Clear content
		// $('.chatbot-response, .chatbot-references').empty();

		// Reset input and specificity
		$('#chatbot-entry').val('');
		resetSpecificityOption();

		// Show the chatbot logo container
		$('.chatbot-logo-container').show();

		// Reset the size and icon state
		$icon.removeClass('fa-compress-alt').addClass('fa-expand-alt');
		$icon.attr('title', 'Expand');

		// Remove all inline styles from .chatbot-contents
		$contents.removeAttr('style');

		// IF they had started providing feedback, and bailed, then reset the variables
		$('#chatbot-entry').css('background-color', '#EFEFEF');
		$('#chatbot-entry').attr('placeholder', 'Ask me a question...');
		$('#chatbot-entry').removeClass('feedback-input');
		lastAnswerBad = false;

		// Reset specific elements
		if (isIOS || isIpadOS) {
			$('.chatbot-entry').css('width', 'auto');
		} else {
			$('.chatbot-entry').css('width', '445px');
		}

		$('.maxx-intelligence-details-container').css('height', '100%');

		// Reset the tooltip
		$icon.tooltip('destroy').tooltip();
	}

	function isMobileDevice() {
	    return (/android/i).test(navigator.userAgent.toLowerCase()) || 
	           (/iPhone|iPad|iPod/).test(navigator.userAgent) || 
	           (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform));
	}	

	function isIOS() {
		if ((/iPad|iPhone|iPod/).test(navigator.platform)) {
		    return true;
		}
		return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform);
	}

	function isIpadOS() {
      return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform);
	}

	function loadChoices() 
	{
		var $choicesContainer = $('.chatbot-choices-container'),
			currentTopic      = Object.keys(endpoints).find(key => endpoints[key].id === askMaxxEndpoint),
			defaultTopic      = $('#ask-maxx-default-topic').val(),
			sessionTopic      = $('#ask-maxx-selected-topic').val();

		// If sessionTopic exists, make it the default topic
		if (sessionTopic) {
			currentTopic = Object.keys(endpoints).find(key => endpoints[key].id === sessionTopic);
			if (currentTopic) {
				askMaxxEndpoint = sessionTopic;
			}
		} else if (defaultTopic) { // If no sessionTopic, use the defaultTopic if it exists
			currentTopic = Object.keys(endpoints).find(key => endpoints[key].id === defaultTopic);
			if (currentTopic) {
				askMaxxEndpoint = defaultTopic;
			}
		}

		$choicesContainer.empty();

		// Add "Topics" label with current topic
		$choicesContainer.append(`
			<div class="chatbot-header-container">
				<div class="chatbot-topics-label" style="visibility: hidden;">
					<div class="chatbot-topics-label-wrapper"
						data-toggle="tooltip" 
						data-placement="left"
						title="Change Topic"
					>
						<div class="dropdown">
							<button class="btn dropdown-toggle" type="button" id="topicDropdown"
									data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
									title="Select Topic">
								<i class="fas fa-sliders-h" aria-hidden="true"></i>
							</button>
							<ul class="dropdown-menu ${isDarkMode ? 'theme--dark' : ''}" aria-labelledby="topicDropdown">
								${Object.keys(endpoints).map((key, index) => {
									return `
									<li>
										<a href="#" class="chatbot-choice ${endpoints[key].id === askMaxxEndpoint ? 'chatbot-choice-active' : ''} ${isDarkMode ? 'theme--dark' : ''}" data-endpoint="${endpoints[key].id}">
											<i class="fas fa-solid ${endpoints[key].icon}" aria-hidden="true"></i> ${key}
										</a>
									</li>
								`;
								}).join('')}
							</ul>
						</div>
						<span class="topic-label">&nbsp;Topic: <span class="current-topic">${currentTopic}</span></span>
						<span class="topic-arrow hidden"><i class="fas fa-arrow-left"></i></span>
					</div>
				</div>
				<div class="chatbot-save-conversation" data-toggle="tooltip" title="This will save your current conversation with Maxx" data-session-id="${$('#chatbot-session-id').val()}">
					<i class="fas fa-save" aria-hidden="true"></i> Save Conversation
				</div>
			</div>
		`);

		// Add click event for dropdown items
		$('.chatbot-choice').on('click', function _chatBotChoiceClicked(e) {
			var $this = $(this),
				endpoint = $this.data('endpoint'),
				topicName = $this.text().trim();

			e.preventDefault();

			// Update active class
			$('.dropdown-menu li').removeClass('active');
			$this.parent().addClass('active');

			// Update current topic and endpoint
			$('.current-topic').text(topicName);
			askMaxxEndpoint = endpoint;
		});
	}

	function toggleTopicLabelAnimation(shouldAnimate) {
		$('.chatbot-topics-label-wrapper').toggleClass('animate-border', shouldAnimate);

		if (shouldAnimate) {
			$('.topic-arrow').removeClass('hidden');
		} else {
			$('.topic-arrow').addClass('hidden');
		}
	}

	function loadMaxxIntelligenceHistory()
	{
		Adzuki.Ajax.get('/Ai/gptHistory/0/1').then(function success(content) {
			var historyHtml = '';

			content.conversations.forEach(function _iterateConversations(item, index) {
				var historyItemId = 'history-item-' + index;
				historyHtml += `
					<div class="history-item" id="${historyItemId}">
						<div class="history-date">${item.created}</div>
						<div class="history-prompt">
							<strong>Prompt:</strong>
							<p>${item.prompt}</p>
						</div>
						<div class="history-response">
							<strong>Response:</strong>
							<p id="history-response-${historyItemId}">${formatResponse(item.response)}</p>
						</div>
						<div class="chatbot-actions">
							<div class="history-copy" data-history-id="${historyItemId}">
								<i class="fa fa-copy" aria-hidden="true"></i> copy response
							</div>
							<div class="history-snippets" data-history-id="${historyItemId}">
								<i class="fa fa-cut" aria-hidden="true"></i> save to snippets
							</div>
						</div>
					</div>
				`;
			});

			$('.maxx-intelligence-history-details').html(historyHtml);
		});
	}

	function logChatbotResponse(endpoint, request, response, exec_time)
	{
		var session_id   = $('#chatbot-session-id').val();
		var request_data = {
			session_id: session_id,
			endpoint  : endpoint,
			exec_time : exec_time,
			request   : JSON.stringify(request),
			response  : JSON.stringify(response),
		};

		Adzuki.Ajax.post('/Ai/logChatbotResponse/', request_data)
		.then(function _logChatbotResponse(response) {
			// response logged, nothing to do here
		});
	}

	// maxx bubble
	function maxxBubble(message, chatbotReplyId, thinking = false, alertMessage = false) {
		let formattedDiv = '';
		// const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
		var currentTopic = Object.keys(endpoints).find(key => endpoints[key].id === askMaxxEndpoint) || 'Unknown';

		const animations = [
			'maxx-thinking-animation.gif',
			'maxx-playing-animation.gif',
			'maxx-running-animation.gif',
			'maxx-scooter.gif',
			'maxx-rowing.gif',
			'maxx-driving.gif'
		];

		const randomIndex = Math.floor(Math.random() * animations.length);
		const randomImage = animations[randomIndex];

		if (thinking) {
			formattedDiv = `
				<div class="chatbot-animations">
					<div class="animation-container">
						<img src="${Adzuki.base_uri}/images/${randomImage}" class="${isExpanded === true ? 'animated-image-slower' : 'animated-image'}" alt="Maxx thinking">
					</div>
				</div>
			`;

			if (mode === 'ask-maxx') {
				$('.chatbot-response').append(formattedDiv);
			} else {
				$('.maxx-intelligence-response').append(formattedDiv);
			}

			// Force a reflow to ensure the animation starts
			$('.animated-image').width();
		} else {
			formattedDiv = `
				<div class="chatbot-maxx-label ${isDarkMode ? 'theme--dark' : ''}">Maxx</div>
				<div class="chatbot-bot-reply ${isDarkMode ? 'theme--dark' : ''} ${alertMessage ? 'chatbot-alert-message' : ''}" id="${chatbotReplyId}" data-topic="${currentTopic}">
					${sanitizeHTML(message)}
				</div>
				<div class="clearfix"></div>`;

			if ((mode === 'ask-maxx' && askMaxxquestionAsked === true) || 
				(mode !== 'ask-maxx' && maxxIntelligenceAsked === true)) {
				formattedDiv += `
					<div class="chatbot-actions">
						<div class="chatbot-left-actions">
							${mode === 'ask-maxx' ? `
							<div class="chatbot-feedback">
								<button class="chatbot-action feedback-thumbs-up chatbot-feedback-button" data-toggle="tooltip" title="Like" data-chatbot-reply-id="${chatbotReplyId}" data-question="${mode === 'ask-maxx' ? askMaxxQuestion : maxxIntelligenceQuestion}"><i class="fas fa-thumbs-up" aria-hidden="true"></i></button>
								<button class="chatbot-action feedback-thumbs-down chatbot-feedback-button" data-toggle="tooltip" title="Dislike" data-chatbot-reply-id="${chatbotReplyId}" data-question="${mode === 'ask-maxx' ? askMaxxQuestion : maxxIntelligenceQuestion}"><i class="fas fa-thumbs-down" aria-hidden="true"></i></button>
							</div>
							` : ''}
						</div>
						<div class="chatbot-right-actions">
							<div class="chatbot-reply-copy" data-chatbot-reply-id="${chatbotReplyId}">
								<button class="chatbot-action" data-toggle="tooltip" title="Copy content" style="${mode === 'ask-maxx' ? `color:${greenColor}` : `color: ${blueColor}`}"><i class="fa fa-copy" aria-hidden="true"></i></button>
							</div>
							${mode === 'maxx-intelligence' ? `
								<div class="chatbot-snippets" data-chatbot-reply-id="${chatbotReplyId}">
									<button class="chatbot-action" data-toggle="tooltip" title="Save to Snippets" style="${mode === 'ask-maxx' ? `color:${greenColor}` : `color: ${blueColor}`}"><i class="fa fa-cut" aria-hidden="true"></i></button>
								</div>
							` : ''}
							<div class="chatbot-ask-again" data-chatbot-reply-id="${chatbotReplyId}" data-question="${mode === 'ask-maxx' ? askMaxxQuestion : maxxIntelligenceQuestion}">
								<button class="chatbot-action" data-toggle="tooltip" title="Ask Maxx Again"  style="${mode === 'ask-maxx' ? `color:${greenColor}` : `color: ${blueColor}`}"><i class="fas fa fa-question" aria-hidden="true"></i></button>
							</div>
						</div>
					</div>
				`;
			}

			if (mode === 'ask-maxx') {
				$('.chatbot-response').append(formattedDiv);
			} else {
				$('.maxx-intelligence-response').append(formattedDiv);
			}
		}
	}

	function resetSpecificityOption() {
		$('.chatbot-specificity-option-button').removeClass('active');
		$('.chatbot-specificity-option-button[data-specificity="concise"]').addClass('active');
	}

	function restartChatBot()
	{
		let welcomeMessage = 'Welcome back! I\'m ready for your next question.';

		if (mode === 'ask-maxx') {
			welcomeMessage += ' You can ask me about destinations, sailings, our trusted partners, and information from CP Genie. ';
		}

		// Hide the reference header
		$('.chatbot-reference-header').addClass('hidden');

		// Clear and reset the chat response area
		$('.chatbot-response').html('');

		// Clear the suggestions
		if (mode === 'ask-maxx') {
			$('.chatbot-specificity').html('');
		}

		// Clear the references
		$('.chatbot-references').html('');

		// Generate a new session ID
		setSessionId();

		// load the choices
		loadChoices();

		// Display the welcome back message
		askMaxxquestionAsked = false;

		// IF they had started providing feedback, and bailed, then reset the variables
		// $('#chatbot-entry').css('background-color', '#EFEFEF');
		$('#chatbot-entry').attr('placeholder', 'Ask me a question...');
		lastAnswerBad = false;

		maxxBubble(welcomeMessage);
	}

	function restartMaxxIntelligence()
	{
		// Display a new random intro message
		const introMessage = getRandomIntro();

		// Clear the existing response
		$('.maxx-intelligence-response').html('');

		// Generate a new session ID
		setMaxxIntelligenceSessionId();

		// Display the welcome back message
		maxxIntelligenceAsked = false;
		maxxBubble(introMessage);
	}

	function scrollContents($obj) {
		$obj.animate({
			scrollTop: $obj[0].scrollHeight
		}, 500);
	}

	function sendChatbotResponse(msg, specificity, ellipsisInterval)
	{
		var response,
			reformattedText,
			chatbotReplyId,
			sessionId = $('#chatbot-session-id').val();

		// when making the request, pass in the message and specificity selected as POST variables
		Adzuki.Ajax.post(
			'/Ai/chatBotRequest/',
			{
				msg        : msg,
				specificity: specificity,
				sessionId  : sessionId,
				endpoint   : endpoints[Object.keys(endpoints).find(key => endpoints[key].id === askMaxxEndpoint)].id
			}
		).then(function _chatbotRequest(content) {
			try {
				response = JSON.parse(content); // Parse content as JSON
			} catch (e) {
				console.error('Failed to parse JSON:', e);
			}

			// Stop the ellipsis animation
			clearInterval(ellipsisInterval);

			$('.chatbot-response').removeClass('hidden');

			// Store the original response text
			reformattedText = response.text;

			// change line breaks for br tags
			reformattedText = reformattedText.replace(/\r\n|\r|\n/g, '<br>');

			// change bold text
			reformattedText = reformattedText.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');

			// Replace ### headings with <h4> tags
			reformattedText = reformattedText.replace(/^### (.*?)$/gm, '<h4>$1</h4>');

			// set the chatbot reply id
			chatbotReplyId = generateRandomString();

			// Add the response to the chatbot
			maxxBubble(reformattedText, chatbotReplyId, false);

			if (response.sourceDocuments !== undefined && response.sourceDocuments.length > 0) {
				const uniqueId = generateRandomString();
				const sources = response.sourceDocuments
					.slice(0, maxReferences)
					.map(document => document.metadata.source);

				addNewReferences(sources, sources.length, uniqueId, msg);
			}

			// scroll the contents of the window
			scrollContents($('.chatbot-response'));

			// remove any animations
			$('.chatbot-animations').remove();
		});
	}

	function sendChatbotStreamedResponse(msg, specificity, ellipsisInterval, endpoint, topic)
	{
		var session_id    = $('#chatbot-session-id').val();
		var raw_answer    = '';
		var source        = null;
		var reply_id      = null;
		var topicFriendly = '';
		var exec_time     = Date.now();
		var response      = {};
		var event_options = {};
		var json_payload  = {
			question      : msg,
			streaming     : true,
			overrideConfig: {
				sessionId: Adzuki.agent_id + '|' + session_id,
			},
		};

		// if (specificity === 'concise') {
		// 	json_payload.question = json_payload.question + '. Provide the answer as concisely as possible.';
		// } else {
		// 	json_payload.question = json_payload.question + '. Provide the answer in detail.';
		// }

		event_options = {
			start  : false,
			payload: JSON.stringify(json_payload),
			headers: {
				'Content-Type': 'application/json',
			}
		};

		// endpoint = endpoints[Object.keys(endpoints).find(key => endpoints[key].id === askMaxxEndpoint)].id;
		source   = new Adzuki.ServerSentEvents(serviceUrl + endpoint, event_options);

		// a connection was made
		source.addEventListener('open', function _onOpen(event) {
			reply_id = generateRandomString();

			if (event.responseCode === 200) {
				// Stop the ellipsis animation
				clearInterval(ellipsisInterval);

				// remove any animations
				$('.chatbot-animations').remove();
				$('.chatbot-response').removeClass('hidden');

				// add empty response, this will be updated once the data comes in
				maxxBubble('', reply_id, false);
			} else {
				source.close();

				// something went wrong, fallback to the default non-streamed response
				maxxBubble(askMaxxErrorRetry, reply_id, false);
				$('.chatbot-animations').remove();
				enableChatbotEntry();

				sendChatbotResponse(msg, specificity, ellipsisInterval);
			}
		});

		// we got a chunk of the chatbot response
		source.addEventListener('message', function _onMessage(event) {
			var message = JSON.parse(event.data);

			switch (message.event) {
				case 'token':
					raw_answer += message.data;

					if (message.data.length > 0) {
						updateMaxxBubble(raw_answer, reply_id);
					}
				break;
				case 'sourceDocuments':
					if (message.data.length > 0) {
						const uniqueId = generateRandomString();
						const sources  = message.data
							.slice(0, maxReferences)
							.map(document => document.metadata.source);

						addNewReferences(sources, sources.length, uniqueId, msg);

						// save into response object for logging
						response.sourceDocuments = message.data;
					}
				break;
				case 'metadata':
					// save into response object for logging
					if (message.data.chatId) {
						response.chatId = message.data.chatId;
					}

					if (message.data.chatMessageId) {
						response.chatMessageId = message.data.chatMessageId;
					}

					if (message.data.memoryType) {
						response.memoryType = message.data.memoryType;
					}

					if (message.data.question) {
						response.question = message.data.question;
					}

					if (message.data.sessionId) {
						response.sessionId = message.data.sessionId;
					}
				break;
				case 'end':
					// close connection
					source.close();

					exec_time = (Date.now() - exec_time) / 1000;

					enableChatbotEntry();

					if (raw_answer) {
						response.text = raw_answer;

						// reformat the response once more as a whole
						updateMaxxBubble(raw_answer, reply_id);
						
						// Check for "hmmm" and add additional text if found
						checkAndAddAdditionalText(reply_id);

						// Append topic information at the bottom of the response
						if (topic) {
							switch (topic) {
								case 'cpgenie':
									topicFriendly = 'CP Genie';
								break;
								case 'partnerhub':
									topicFriendly = 'Partner Hub';
								break;
								case 'sailings':
									topicFriendly = 'Sailings';
								break;
								case 'fodors':
									topicFriendly = 'Destinations';
								break;
								default:
									topicFriendly = topic;
								break;
							}

							if (raw_answer.toLowerCase().indexOf('hmm') !== -1) {
								topicFriendly = 'Uncertain';
							}

							const topicText = `<br><small class="chatbot-topic-label">Topic: ${topicFriendly}</small>`;
							$('#' + reply_id).append(topicText);

							// // show dem bubbles
							// if (mode === 'ask-maxx') {
							// 	showFollowupBubbles(endpoint);
							// }
						}
					} else if (response.error) {
						// we got a streaming error, send error response asking the agent to try again
						updateMaxxBubble(askMaxxErrorResponse, reply_id);
					} else {
						// something went wrong, fallback to the default non-streamed response
						updateMaxxBubble(askMaxxErrorRetry, reply_id);

						sendChatbotResponse(msg, specificity, ellipsisInterval);
					}

					logChatbotResponse(endpoint, json_payload, response, exec_time);

					// generate follow ups based on the response
					if (mode === 'ask-maxx' && topicFriendly !== 'Uncertain') {
						generateFollowUps(raw_answer);
					}

					// cleanup
					raw_answer = null;
					response   = null;
				break;
				case 'error':
					response.error = message.data;
				break;
				default:
					// nothing to do here
				break;
			}
		});

		// an error happened, close the connection
		// and fallback to the default non-streamed response
		source.addEventListener('error', function _onError(event) {
			source.close();

			if (reply_id) {
				updateMaxxBubble(askMaxxErrorRetry, reply_id);
			} else {
				maxxBubble(askMaxxErrorRetry, reply_id, false);
			}

			enableChatbotEntry();
			sendChatbotResponse(msg, specificity, ellipsisInterval);
		});

		source.stream();
	}

	// Add this new function
	function checkAndAddAdditionalText(reply_id) {
		var $bubble        = $('#' + reply_id + '.chatbot-bot-reply').first();
		var contents       = $bubble.html();
		var additionalText = ""; // "<br><br>Please check the <b>topic</b> at the top 👆 of this screen to help me answer your question correctly.";

		if (contents.toLowerCase().includes('hmm') || contents.toLowerCase().includes('I\'m sorry')) {
			$bubble.append(additionalText);

			toggleTopicLabelAnimation(true);

			// Scroll to show the new content
			scrollContents($('.chatbot-response'));
		}
	}

	function sendFeedback() {
		var explanation = $('#chatbot-entry').val();
		$('#chatbot-entry').val('');

		// let's flip the stuff back for entry box
		$('#chatbot-entry').css('background-color', '#EFEFEF');
		$('#chatbot-entry').attr('placeholder', 'Ask me a question...');

		maxxBubble('Your feedback is pawsitively appreciated! Feel free to keep those questions coming—I\'m here to help! 🐶✨', '', false);
		scrollContents($('.chatbot-response'));

		badQuestionDetails.explanation = explanation;

		// send the data to the server
		Adzuki.Ajax.post('/Ai/sendFeedback/', badQuestionDetails)
		.then(function _sendFeedback(response) {
			// nothing to do
		});

		// resets the variables 
		lastAnswerBad        = false;
		askMaxxquestionAsked = true;
		badQuestionDetails   = {};
	}

	// send message to maxx intelligence
	function sendMaxxIntelligence(msg)
	{
		var prompt         = msg,
			prompt_trimmed = prompt.trim(),
			responses      = '',
			maxxSessionId  = $('#maxx-intelligence-session-id').val(),
			ellipsisInterval,
			formattedResponse,
			$ellipsis;

		advisorBubble(msg);
		maxxBubble("I\m thinking", maxxSessionId, true);

		// Animate ellipsis
		ellipsisInterval = setInterval(function _chatBotEllipsisInterval() {
			$ellipsis = $('#intell-loading-message .ellipsis');
			switch ($ellipsis.text()) {
				case '':
					$ellipsis.text('.');
					break;
				case '.':
					$ellipsis.text('..');
					break;
				case '..':
					$ellipsis.text('...');
					break;
				default:
					$ellipsis.text('');
			}
		}, 500);

		if (prompt_trimmed.length === 0) {
			Adzuki.StatusMessage('Error', 'Please provide a full prompt in order to proceed.');
		} else {
			// replace line breaks with spaces in prompt_trimmed
			prompt_trimmed = prompt_trimmed.replace(/(\r\n|\n|\r)/gm, " ");

			// clear the maxx intelligence entry box
			maxxIntelligenceQuestion = $('#maxx-intelligence-entry').val();
			$('#maxx-intelligence-entry').val('');

			// toggle maxx intelligence asked
			maxxIntelligenceAsked = true;

			Adzuki.Ajax.post('/Ai/processPrompt/', {prompt: prompt_trimmed}).then(function success(content) {
				$.each(content.messages, function onEachMessage(i, message) {
					responses += message + "\r\n";
				});

				formattedResponse = responses
				// Separate the intro text from the list
				.replace(/^([\s\S]*?)\n(\d+\.\s+)/, '<p>$1</p><ul><li>')
				// Replace numbered items with list items
				.replace(/\n\d+\.\s+/g, '</li><li>')
				// Make text within ** bold
				.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
				// Close the last list item and the unordered list
				.replace(/(<li>[\s\S]*?)$/, '$1</li></ul>');

				maxxBubble(formattedResponse, generateRandomString(), false);
				clearInterval(ellipsisInterval);

				// Scroll .maxx-intelligence-response to the bottom
				scrollContents($('.maxx-intelligence-response'));

				// remove any animations
				$('.chatbot-animations').remove();
			});
		}
	}

	// send message to the chatbot
	function sendMessage(msg)
	{
		var specificity,
			ellipsisInterval,
			$ellipsis,
			endpoint;

		toggleTopicLabelAnimation(false);

		// if the last answer was bad, what's sent next is going to be feedback
		if (lastAnswerBad === true) {
			sendFeedback();
		} else {
			// add the question into the chatbot response box
			advisorBubble(msg);

			// Add "I'm looking this up" message with animated ellipsis
			maxxBubble('I\'m looking this up', '', true);

			// Animate ellipsis
			ellipsisInterval = setInterval(function _chatBotEllipsisInterval() {
				$ellipsis = $('#loading-message .ellipsis');
				switch ($ellipsis.text()) {
					case '':
						$ellipsis.text('.');
						break;
					case '.':
						$ellipsis.text('..');
						break;
					case '..':
						$ellipsis.text('...');
						break;
					default:
						$ellipsis.text('');
				}
			}, 500);

			scrollContents($('.chatbot-response'));

			// Set specificity based on the active button
			specificity = $('.chatbot-specificity-option-button.active').data('specificity');

			// clear the chatbot entry box
			askMaxxQuestion = $('#chatbot-entry').val();
			disableChatbotEntry();

			// toggle question asked
			askMaxxquestionAsked = true;

			// toggle save conversation button
			$('.chatbot-save-conversation').css('color', '#39B54A');

			// set the session value for the topic
			Adzuki.Ajax.get('/Ai/saveTopic/' + askMaxxEndpoint).then(function success(content) {
				// console.log(content);
			});

									
			Adzuki.Ajax.post('/Ai/getEndpoint/', {msg: msg}).then(function success(content) {
				endpoint = content.endpoint;
				topic    = content.topic;

				// console.log('ENDPOINT ' + endpoint + ' ENDPOINT NAME ' + Object.keys(endpoints).find(key => endpoints[key].id === endpoint));
				
				// if they got a followup, use the endpoint override so that it goes to the proper endpoint
				if (endpoint === 'followup') {
					endpoint = endpointOverride;
					topic    = Object.keys(endpoints).find(key => endpoints[key].id === endpoint) || null;
				} else {
					endpointOverride = endpoint;
				}

				sendChatbotStreamedResponse(msg, specificity, ellipsisInterval, endpoint, topic);
			});
		}
	}

	function sendToSnippets($obj)
	{
		var responseText = $obj.html().trim();

		Adzuki.Ajax.post('/Ai/saveSnippet/', {snippet: responseText}).then(function success(content) {
			maxxIntelligenceAsked = false;

			if ($('.maxx-intelligence-option-button.active').data('option') === 'history') { // eslint-disable-line no-lonely-if
				Adzuki.StatusMessage('Success', 'Saved to snippets');
			} else {
				maxxBubble('Woof! 🐶 I just saved it to your snippets');
				scrollContents($('.maxx-intelligence-response'));
			}
		});
	}

	// set session id
	function setSessionId()
	{
		var sessionId = generateRandomString();
		var timestamp = new Date().getTime();
		$('#chatbot-session-id').val(sessionId + '_' + timestamp);
	}

	function setMaxxIntelligenceSessionId()
	{
		var maxxSessionId = generateRandomString();
		var timestamp     = new Date().getTime();
		$('#maxx-intelligence-session-id').val(maxxSessionId + '_' + timestamp);
	}

	function setSpecificity(specificity)
	{
		Adzuki.Ajax.post(
			'/Ai/chatBotRequest/',
			{
				msg        : `For future questions, please respond in a ${specificity} manner. No need to respond to the previous message.`,
				specificity: specificity,
				sessionId  : $('#chatbot-session-id').val(),
				endpoint   : endpoints[Object.keys(endpoints).find(key => endpoints[key].id === askMaxxEndpoint)].id
			}
		).then(function _endSession(content) {
			// console.log(content);
		});
	}

	// set user photo in after
	function setUserPhotoInAfter()
	{
		var photoUrl = $('.photo').css('background-image');

		// Create a style element if it doesn't exist
		if (!$('#dynamic-styles').length) {
			$('head').append('<style id="dynamic-styles"></style>');
		}

		// Update or add the CSS rule
		$('#dynamic-styles').html('.chatbot-user-label::after { background-image: ' + photoUrl + '; }');
	}

	// show chatbot
	function showChatBot()
	{
		// Add backdrop
		$('body').append('<div class="chatbot-backdrop"></div>');
		$('.chatbot-backdrop').fadeIn();

		$('.chatbot-contents').removeClass('hidden');
		$('.chatbot-contents').slideDown();

		if ($('#chatbot-session-id').val() === '') {
			// if there is no session id set, do it
			setSessionId();

			// send a random message when it starts
			maxxBubble(getRandomIntro());
		}

		// load the topics that Maxx can choose from
		loadChoices();

		// Hide the chatbot logo container
		$('.chatbot-logo-container').hide();

		// reset the height of the chatbot
		setTimeout(function _setHeight() {
			$('.chatbot-contents').css('height', '650px');
		}, 500);
	}

	// // show bubbles
	// function showFollowupBubbles(followups) 
	// {
	// 	const bubblesHtml = `
	// 		'Simplify this'
	// 	];

	// 	const bubblesHtml = `
	// 		<div class="chatbot-followups">
	// 			${followups.map(followup => `
	// 				<button class="chatbot-followup-bubble" data-followup="${followup}" data-endpoint="${endpoint}">
	// 					${followup}
	// 				</button>
	// 			`).join('')}
	// 		</div>
	// 	`;
		
	// 	$('.chatbot-specificity').html(bubblesHtml);

	// 	scrollContents($('.chatbot-response'));
	// }

	function showFollowupBubblesNew(followups) 
	{
		let bubblesHtml = '<div class="chatbot-followups">';

		followups.forEach(followup => {
			bubblesHtml += `<button class="chatbot-followup-bubble" data-followup="${followup}" data-endpoint="">${followup}</button>`;
		});

		bubblesHtml += '</div>';
		$('.chatbot-specificity').html(bubblesHtml);

		scrollContents($('.chatbot-response'));
	}

	// show maxx intelligence
	function showMaxxIntelligence()
	{
		$('.chatbot-maxx-intelligence-container').show();
	}

	function textToSpeech() {
		const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

		if (SpeechRecognition) {
			const recognition = new SpeechRecognition();
			recognition.continuous = false;
			recognition.interimResults = true;
			recognition.lang = "en-US";
			recognition.maxAlternatives = 1;

			const $microphoneIcon = $('.chatbot-microphone.active');
			const $textArea = $microphoneIcon.siblings('textarea');

			recognition.onstart = function _recognitionStart() {
				$microphoneIcon.empty().append('<i class="fas fa-spinner fa-spin" id="recognition-spinner"></i>');
			};

			recognition.onspeechend = function _recognitionSpeechEnd() {
				recognition.stop();
			};

			recognition.onend = function _recognitionEnd() {
				$microphoneIcon.empty();
				$microphoneIcon.removeClass('active');
			};

			recognition.onresult = function _recognitionResult(event) {
				let interimTranscript = '';
				let finalTranscript = '';

				for (let i = event.resultIndex; i < event.results.length; ++i) {
					if (event.results[i].isFinal) {
						finalTranscript += event.results[i][0].transcript;
					} else {
						interimTranscript += event.results[i][0].transcript;
					}
				}

				// Display interim results
				if (interimTranscript !== '') {
					$textArea.val(interimTranscript);
				}

				// Update with final results
				if (finalTranscript !== '') {
					$textArea.val(finalTranscript);
				}
			};

			recognition.onerror = function _recognitionError(event) {
				console.error('Speech recognition error:', event.error);
				$microphoneIcon.empty().append('<i class="fas fa-microphone"></i>');
				$microphoneIcon.removeClass('active');
				Adzuki.StatusMessage('error', 'Ensure that your microphone is turned on and/or your device is not muted.', 'Speech Recognition Error');
			};

			recognition.start();
			window.recognition = recognition;  // Store the recognition object globally
		} else {
			Adzuki.StatusMessage('error', 'Speech recognition is not supported in this browser. Please use Chrome for this feature.', 'Browser Not Supported');
		}
	}

	function sanitizeHTML(html) {
		let formattedText = '';

		// Skip link formatting if text contains cpmaxx or adzuki
		if (html.toLowerCase().includes('cpmaxx') || html.toLowerCase().includes('adzuki')) {
			return html;
		}

		if (containsMarkdown(html)) {
			formattedText = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
		} else {
			formattedText = html.replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>');
		}

		return formattedText;
	}

	function updateMaxxBubble(bubble_contents, reply_id)
	{
		// get the reply with the id
		var $bubble       = $('#' + reply_id + '.chatbot-bot-reply').first();
		var $response_win = $('.chatbot-response').first();
		var contents      = bubble_contents;

		// re-format the contents if there is markdown
		if (containsMarkdown(contents)) {
			contents = formatResponse(contents);
		}

		// update the bubble
		$bubble.html(contents);

		// scroll the contents of the window (no animation)
		$response_win.scrollTop($response_win.prop('scrollHeight'));
	}

	function containsMarkdown(text) {
		// Regular expressions for common Markdown patterns
		const patterns = [
			/\[.+?\]\(.+?\)/,          // Links: [text](url)
			/\*\*.+?\*\*/,             // Bold: **text**
			/\*.+?\*/,                 // Italic: *text*
			/^#{1,6}\s.+/m,            // Headers: # Header
			/`{1,3}[\s\S]+?`{1,3}/,    // Code: `code` or ```code block```
			/^\s*[-*+]\s/m,            // Unordered lists: - item or * item or + item
			/^\s*\d+\.\s/m,            // Ordered lists: 1. item
			/^\s*>.+/m,                // Blockquotes: > quote
			/!\[.+?\]\(.+?\)/,         // Images: ![alt text](url)
			/~~.+?~~/,                 // Strikethrough: ~~text~~
			/^\s*[-*_]{3,}\s*$/m       // Horizontal rules: --- or *** or ___
		];

		// Test each pattern against the text
		return patterns.some(pattern => pattern.test(text));
	}

	function stripHtmlAndFormat(html) {
		// Create a temporary element to parse the HTML
		var temp = document.createElement("div"),
			text = '';
		temp.innerHTML = html;
	
		// Get the text content
		text = temp.textContent || temp.innerText || "";
	
		// Replace common HTML elements with Markdown-like formatting
		text = text.replace(/\n{3,}/g, '\n\n'); // Replace multiple newlines with double newlines
		text = text.replace(/<\/?h[1-6]>/gi, '**'); // Replace header tags with bold
		text = text.replace(/<\/?strong>/gi, '**'); // Replace strong tags with bold
		text = text.replace(/<\/?b>/gi, '**'); // Replace b tags with bold
		text = text.replace(/<\/?em>/gi, '_'); // Replace em tags with italic
		text = text.replace(/<\/?i>/gi, '_'); // Replace i tags with italic
		text = text.replace(/<li>/gi, '• '); // Replace list items with bullet points
		text = text.replace(/<\/li>/gi, '\n'); // Add newline after list items
		text = text.replace(/<\/p>/gi, '\n\n'); // Add double newline after paragraphs
		
		// Replace links
		text = text.replace(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"[^>]*>(.*?)<\/a>/gi, function _replaceLinks(match, url, linkText) {
			return linkText + ' (' + url + ')';
		});
	
		// Remove any remaining HTML tags
		text = text.replace(/<[^>]+>/g, '');
	
		// Trim extra whitespace
		text = text.trim();
	
		return text;
	}

	function generateFollowUps(answer) {
		let msg               = '';
		let jsonString        = '';
		let data              = '';
		let parsedData        = '';
		let followups         = {};

		// let sessionId         = $('#chatbot-session-id').val();
		const endpointPrompts = {
			'e0a0e6a7-74f0-49f2-83c9-79d77d6ed1e8': 'You provide insights into global place/destinations using Fodor\'s hierarchical data structure. This includes navigating levels such as \'World Region,\' \'Country,\' \'State,\' \'Location,\' and \'Destination.\' Your goal is to help users explore destinations and uncover specific travel insights tied to each location. Generate a list of 3 highly relevant follow up questions that are specific to the answer provided.', // Destinations
			'47a7329e-6ee9-4885-bfef-04c5112ce777': 'You deliver critical information sourced from Cruise Planners\' trusted partners/vendors - recognized by Name/Entity. This includes details about cruise line benefits, sales, commission rates, and contact information, supporting agents in leveraging partnerships effectively. Generate a list of 3 highly relevant follow up questions that are specific to the answer provided.', // Partners
			'7c8412a2-d553-4d05-8c9e-7df8fae905a9': 'You maintain up-to-date listings of upcoming cruise sailings, with key details like start and end dates, visited ports, and cruise line information. Your role is to assist users in finding specific sailings or accessing schedules quickly. Generate a list of 3 highly relevant follow up questions that are relevant to the answer provided', // Sailings
			'e96551ca-1928-4c49-8f65-d527481dd3f6': 'As the knowledge hub of Cruise Planners, CP Genie helps users access the Learning Management System (LMS) for "Wh" questions regarding guidelines, documentation/usage guides of Cruise Planner (CP) Tools, Home Office (HO) websites, convention/events, resources, operational insights, travel protection and any other specific terminology or jargon that Cruise Planners uses. This is particularly useful for franchisees and agents seeking training or operational support.Generate a list of 3 highly relevant follow up questions that are specific to the answer provide.', // CP Genie
		};

		// message to maxx
		msg = endpointPrompts[endpointOverride] + '. Here is the original answer: ' + answer + '. Please generate 3 followup questions in no more than 35 characters each if possible. Return the response in JSON format with the key "followups" and an array of strings.';
		
		$('.chatbot-specificity').html('<i class="fas fa-spinner fa-spin"></i> checking followups...');

		Adzuki.Ajax.post('/Ai/processPrompt/', {
			prompt  : msg, 
			agent_id: '1'
		}).then(function _chatbotRequest(content) {
			try {
				data = content.messages;

				if (Array.isArray(data) && typeof data[0] === 'string') {
					// Remove the starting "```json" and the ending "```" using regex
					jsonString = data[0].replace(/^```json\s*|\s*```$/g, '');
					// Parse the cleaned JSON string
					parsedData = JSON.parse(jsonString);
					// Get the followups array
					followups = parsedData.followups;
				} else {
					console.error('Unexpected data format:', data);
				}
				
				// if there are followups, show them
				if (followups.length > 0) {
					console.log('followups', followups);
					showFollowupBubblesNew(followups);
				}

			} catch (error) {
				console.error("Error parsing JSON:", error);
			}
		});
	}
}(jQuery, window.Adzuki || {}));
